import React from 'react';
import PropTypes from "prop-types";
import axios from 'axios';
import Spinner from "../../../qwc2/components/widgets/Spinner";
import LocaleUtils from "../../../qwc2/utils/LocaleUtils";
import AbstractTab from "./AbstractTab";
import {connect} from "react-redux";
import {addDetailWindow, setDetailWindow} from "../../actions/details";
import FeatureUtils from "../../utils/FeatureUtils";

class AjaxTab extends AbstractTab {

    static propTypes = {
        addDetailWindow: PropTypes.func,
        feature: PropTypes.object,
        setDetailWindow: PropTypes.func,
        tab: PropTypes.object,
        windowId: PropTypes.string,
        windowType: PropTypes.string
    }

    static defaultProps = {
        feature: {},
        tab: {},
        windowId: ''
    }

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            isLoading: true
        };
    }

    componentDidMount() {
        const url = FeatureUtils.prepareUrl(this.props.feature, this.props.tab.url);
        const self = this;
        axios(url).then(response => {
            self.setState({
                data: response.data,
                isLoading: false
            });
        }).catch(error => {
            console.log("Error *** : " + error);
        });
    }

    render() {
        return (
            <div className="feature-details-ajax">
                {this.state.isLoading &&
                    <div>
                        <Spinner/>
                        <div>{LocaleUtils.tr("attribtable.loading")}</div>
                    </div>
                }
                {!this.state.isLoading &&
                    <div>
                        {this.renderData()}
                    </div>
                }
            </div>
        );
    }

    renderData() {
        return JSON.stringify(this.state.data);
    }
}

const selector = () => ({});

export default connect(selector, {
    setDetailWindow: setDetailWindow,
    addDetailWindow: addDetailWindow,
})(AjaxTab);
